import { render, staticRenderFns } from "./SurveyAnsweredBadge.vue?vue&type=template&id=a6c33df0"
import script from "./SurveyAnsweredBadge.vue?vue&type=script&lang=js"
export * from "./SurveyAnsweredBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports